export default "__VITE_ASSET__DX0cDqIS__"